import React, { useState } from "react";
import ReactPlayer from "react-player";

export default function VideoComponent({ videoSrc, description }) {
    const [playing, setPlaying] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handlePlayPause = () => {
        setPlaying(!playing);
    };

    return (
        <div className="min-h-screen flex flex-col lg:items-center lg:justify-center md:items-center md:justify-center sm:items-center sm:mt-2 px-2 sm:px-4 lg:px-8 bg-white">
            <div className="w-full xl:max-w-6xl lg:max-w-4xl md:max-w-3xl sm:max-w-2xl relative">
                <div 
                    className="relative aspect-video rounded-3xl shadow-xl overflow-hidden"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <ReactPlayer 
                        src={videoSrc} 
                        controls={true} 
                        width="100%" 
                        height="100%" 
                        playing={playing}
                        onPlay={() => setPlaying(true)}
                        onPause={() => setPlaying(false)}
                    />
                    {!playing && (
                        <div 
                            className="absolute inset-0 flex items-center justify-center cursor-pointer z-10"
                            onClick={handlePlayPause}
                        >
                            <div 
                                className={`
                                    w-24 h-24 rounded-full flex items-center justify-center transition-all duration-300
                                    ${isHovered 
                                        ? 'bg-orange-500 scale-110' 
                                        : 'bg-black bg-opacity-50'
                                    }
                                `}
                            >
                                <svg 
                                    className="w-12 h-12 text-white" 
                                    fill="currentColor" 
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M8 5v14l11-7z" strokeLinejoin="round" strokeLinecap="round" />
                                </svg>
                            </div>
                        </div>
                    )}
                </div>
                <p className="mt-6 -mx-4 text-black font-roboto font-normal text-base leading-relaxed text-left">
                    {description}
                </p>
            </div>
        </div>
    );
}
